<div class="container-circles">
  <div class="circle c-green"></div>
  <div class="circle c-red"></div>
  <div class="circle c-orange"></div>
  <div class="c-blue"></div>
</div>
<div class="container-info">
  <div class="m-top-20">No Internet Connection</div>
  <div class="m-top-20">This page will automatically refresh when you are back online</div>
</div>